// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { cityCodes } from 'helpers/countryHelpers';
// Material Dashboard 2 PRO React context - MUI 7 uyumluluğu için kaldırıldı
// import { useMaterialUIController } from 'context';

function ShippingInformation({ shipping }) {
    // MUI 7 uyumluluğu için context kullanımı kaldırıldı
    // const [controller] = useMaterialUIController();
    // const { darkMode } = controller;

    return (
        <MDBox>
            <MDTypography
                variant="h6"
                fontWeight="medium"
                component="a"
                href="https://docs.google.com/spreadsheets/d/1qmWGlJsfh5X3DiiC594SfiOLJxM35yj-u2Q2DPjSiyo/edit?gid=0#gid=0"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    color: '#374151',
                    marginBottom: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    textDecoration: 'none',
                    '&:hover': {
                        color: '#10B981',
                    },
                }}
            >
                <MDBox
                    sx={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: '#10B981',
                        borderRadius: '4px',
                        marginRight: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <MDTypography sx={{ color: 'white', fontSize: '12px', fontWeight: 'bold' }}>🚚</MDTypography>
                </MDBox>
                Teslimat Bilgileri
            </MDTypography>
            <MDBox
                sx={{
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                    border: '1px solid #e2e8f0',
                    borderRadius: '16px',
                    padding: '20px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    '&:hover': {
                        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                        transform: 'translateY(-2px)',
                    },
                }}
            >
                <MDBox width="100%" display="flex" flexDirection="column" lineHeight={1}>
                    <MDBox mb={3}>
                        <MDTypography
                            variant="h6"
                            fontWeight="bold"
                            sx={{
                                color: '#1f2937',
                                fontSize: '1.1rem',
                            }}
                        >
                            {`${shipping?.first_name || ''} ${shipping?.last_name || ''}`.trim() ||
                                'Teslimat Bilgisi Yok'}
                        </MDTypography>
                    </MDBox>

                    {[
                        { label: '🏢 Firma', value: shipping?.company || '-' },
                        {
                            label: '📍 Adres',
                            value: `${shipping?.address_1 || ''}${
                                shipping?.address_2 ? `, ${shipping.address_2}` : ''
                            }`,
                        },
                        {
                            label: '🌍 İl/İlçe',
                            value: `${shipping?.city || ''}, ${cityCodes[shipping?.state] || ''} ${
                                shipping?.postcode || ''
                            }`,
                        },
                    ].map((item, index) => (
                        <MDBox key={index} mb={2}>
                            <MDBox
                                sx={{
                                    backgroundColor: '#f9fafb',
                                    border: '1px solid #e5e7eb',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <MDTypography
                                    variant="caption"
                                    sx={{
                                        color: '#6b7280',
                                        fontWeight: '600',
                                        minWidth: '80px',
                                        fontSize: '0.75rem',
                                    }}
                                >
                                    {item.label}:
                                </MDTypography>
                                <MDTypography
                                    variant="caption"
                                    sx={{
                                        color: '#374151',
                                        fontWeight: '500',
                                        marginLeft: '8px',
                                        fontSize: '0.8rem',
                                    }}
                                >
                                    {item.value}
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                    ))}

                    {shipping?.phone && (
                        <MDBox>
                            <MDBox
                                sx={{
                                    backgroundColor: '#f0fdf4',
                                    border: '1px solid #bbf7d0',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <MDTypography
                                    variant="caption"
                                    sx={{
                                        color: '#6b7280',
                                        fontWeight: '600',
                                        minWidth: '80px',
                                        fontSize: '0.75rem',
                                    }}
                                >
                                    📱 Telefon:
                                </MDTypography>
                                <MDTypography
                                    variant="caption"
                                    sx={{
                                        color: '#374151',
                                        fontWeight: '500',
                                        marginLeft: '8px',
                                        fontSize: '0.8rem',
                                    }}
                                >
                                    {shipping.phone}
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                    )}
                </MDBox>
            </MDBox>
        </MDBox>
    );
}

export default ShippingInformation;
